module.exports = __webpack_public_path__ + "pdf/ceo.4f58633.pdf";